/* FalcX fitment page (r7, fit-install). Loaded without defer right after the "What fits" panels, so the panel for the
   vehicle on show is unhidden before the page paints (no jump). The vehicle on show follows falcx-finder.js: a link that
   names a series (?series=&body=) wins, with its body when it names one, else the body style of the browse (else saved)
   vehicle of that series, else sedan; otherwise the effective vehicle (r2 13 Oct 2026: the browse vehicle of this visit,
   sessionStorage falcx-browse-vehicle-v1, else the saved one, localStorage falcx-my-vehicle-v1). "What fits your …"
   only for the saved vehicle. Aliases the finder does not know (fg-x, fg-fgx) are rewritten in the address bar first.
   Once falcx-finder.js has run, FalcxVehicle.getActive() decides, and every change of vehicle repaints the panel.
   r10 (fitment): the series filter above the fitment cards. The choice is a data-fxfp attribute on [data-fxft], set
   here before the cards are parsed, and falcx-fitp.css hides the other cards from it (no jump, nothing removed from the
   HTML). It opens on: a #link into a card (#ba-bf-ute, #fit-au, #gen-fg-fgx), else what was tapped in this tab for the
   same vehicle (sessionStorage), else the series of the vehicle on show, else All. Picking a Falcon selects its series. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.FalcxFit = api; api.boot(); }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  var STORE = 'falcx-my-vehicle-v1';
  var BROWSE = 'falcx-browse-vehicle-v1';
  var ALIAS = {'ea-el': 'ea-ed', 'ea-au': 'ea-ed', 'fg-fgx': 'fg', 'fg-x': 'fgx'};
  var FILTER_KEY = 'falcx-fitp-filter-v1';
  var SERIES = ['ea-ed', 'ef-el', 'au', 'ba-bf', 'fg', 'fgx'];
  var LABEL = {'ea-ed': 'EA–ED', 'ef-el': 'EF–EL', 'au': 'AU', 'ba-bf': 'BA–BF', 'fg': 'FG', 'fgx': 'FGX'};
  /* Generation wrappers: one series each, or two (then the filter shows All). */
  var GEN = {'gen-ea-el': 'all', 'gen-au': 'au', 'gen-ba-bf': 'ba-bf', 'gen-fg-fgx': 'all'};
  var shownKey = '';
  function normalize(value) { var s = String(value || '').toLowerCase().trim(); return ALIAS[s] || s; }
  function keyOf(v) { return v ? v.series + '/' + v.body : ''; }
  function find(list, series, body) {
    for (var i = 0; i < list.length; i++) if (list[i].series === series && list[i].body === body) return list[i];
    return null;
  }
  /* A pair the data does not list (an FG wagon) falls back to that series' sedan, as in the finder. */
  function resolve(list, series, body) { return find(list, series, body) || find(list, series, 'sedan'); }
  function parseSaved(raw, list) {
    if (!raw) return null;
    try {
      var o = JSON.parse(raw);
      if (o && typeof o === 'object') return resolve(list, normalize(o.series), String(o.body || 'sedan').toLowerCase());
      if (typeof o === 'string') { for (var i = 0; i < list.length; i++) if (list[i].key === o) return list[i]; }
    } catch (e) { /* unreadable: no vehicle */ }
    return null;
  }
  function knows(list, series) { for (var i = 0; i < list.length; i++) if (list[i].series === series) return true; return false; }
  /* The vehicle the page opens on, and where it came from ('link', 'browse', 'saved' or 'none'). */
  function initial(search, savedRaw, list, browseRaw) {
    var q = new URLSearchParams(search || '');
    var saved = parseSaved(savedRaw, list);
    var browse = parseSaved(browseRaw, list);
    var eff = browse || saved;
    var series = q.has('series') ? normalize(q.get('series')) : '';
    if (series && knows(list, series)) {
      var linkBody = String(q.get('body') || '').toLowerCase();
      var same = browse && browse.series === series ? browse : saved && saved.series === series ? saved : null;
      var body = linkBody || (same ? same.body : 'sedan');
      return {vehicle: resolve(list, series, body), from: 'link', saved: saved};
    }
    return {vehicle: eff, from: browse ? 'browse' : saved ? 'saved' : 'none', saved: saved};
  }
  /* The address with the vehicle written the way falcx-finder.js reads it, or null when nothing needs to change. */
  function canonicalSearch(search, vehicle) {
    var q = new URLSearchParams(search || '');
    if (!vehicle) return null;
    if (q.get('series') === vehicle.series && q.get('body') === vehicle.body) return null;
    q.set('series', vehicle.series); q.set('body', vehicle.body);
    return '?' + q.toString();
  }
  function validFilter(f) { return f === 'all' || SERIES.indexOf(f) !== -1; }
  /* The filter a #hash needs: the card's series (#ba-bf-ute, #fit-ba-bf, #gen-ba-bf), 'all' for a generation with two
     series, or null when the hash is not in the cards (#xr-fpv, #which-falcon …). */
  function hashFilter(hash) {
    var id = String(hash || '').replace(/^#/, '');
    try { id = decodeURIComponent(id); } catch (e) { /* keep as is */ }
    id = id.toLowerCase();
    if (!id) return null;
    if (Object.prototype.hasOwnProperty.call(GEN, id)) return GEN[id];
    var m = /^(fit-)?(ea-ed|ef-el|au|ba-bf|fgx|fg)(-(sedan|ute|wagon))?$/.exec(id);
    if (!m || (!m[1] && !m[3]) || (m[1] && m[3])) return null;
    return m[2];
  }
  /* The filter the cards open on (see the note at the top). sessionRaw: {"f": filter, "v": vehicle key when tapped}. */
  function initialFilter(hash, sessionRaw, vehicle) {
    var h = hashFilter(hash);
    if (h) return h;
    var saved = null;
    try { saved = JSON.parse(sessionRaw || 'null'); } catch (e) { saved = null; }
    if (saved && typeof saved === 'object' && validFilter(saved.f) && String(saved.v || '') === keyOf(vehicle)) return saved.f;
    return vehicle && validFilter(vehicle.series) ? vehicle.series : 'all';
  }
  function filterStatus(f) { return validFilter(f) && f !== 'all' ? 'Showing the ' + LABEL[f] + ' Falcon' : 'Showing every Falcon'; }
  function setFilter(page, f, opts) {
    opts = opts || {};
    if (!validFilter(f)) f = 'all';
    page.setAttribute('data-fxfp', f);
    page.querySelectorAll('[data-fxfp-chip]').forEach(function (b) {
      var on = String(b.getAttribute('data-fxfp-chip') === f);
      if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
    });
    if (opts.announce) { var st = page.querySelector('[data-fxfp-status]'); if (st) st.textContent = filterStatus(f); }
    if (opts.remember) { try { sessionStorage.setItem(FILTER_KEY, JSON.stringify({f: f, v: shownKey})); } catch (e) { /* storage blocked */ } }
  }
  /* A link to a card the filter hides shows that series (or All) first. */
  function reveal(page, id) {
    var el = id && document.getElementById(id);
    if (!el || !el.closest || !el.closest('.fxfp-cards') || el.getClientRects().length) return;
    setFilter(page, hashFilter('#' + id) || 'all', {announce: true, remember: true});
  }

  /* "What fits your BA–BF Ute" for the remembered vehicle, "What fits the FG Sedan" for one a link shows. */
  function kicker(mine) { return mine ? 'What fits your' : 'What fits the'; }

  function boot() {
    if (typeof document === 'undefined') return;
    var page = document.querySelector('[data-fxft]');
    var data = document.querySelector('[data-falcx-vehicle-data]');
    if (!page || !data) return;
    var list;
    try { list = JSON.parse(data.textContent); } catch (e) { return; }
    var savedRaw = null;
    try { savedRaw = localStorage.getItem(STORE); } catch (e) { /* storage blocked */ }
    var browseRaw = null;
    try { browseRaw = sessionStorage.getItem(BROWSE); } catch (e) { /* storage blocked */ }
    var start = initial(window.location.search, savedRaw, list, browseRaw);
    if (start.from === 'link') {
      var fixed = canonicalSearch(window.location.search, start.vehicle);
      var raw = new URLSearchParams(window.location.search).get('series');
      /* Only an alias the finder cannot read is rewritten before it runs; the body rule is the finder's own business. */
      if (fixed && raw && ALIAS[String(raw).toLowerCase()] && window.history.replaceState) {
        var q = new URLSearchParams(window.location.search); q.set('series', start.vehicle.series);
        window.history.replaceState(null, '', window.location.pathname + '?' + q.toString() + window.location.hash);
      }
    }
    show(page, start.vehicle, !!(start.saved && start.vehicle && start.saved.key === start.vehicle.key));
    var sessionRaw = null;
    try { sessionRaw = sessionStorage.getItem(FILTER_KEY); } catch (e) { /* storage blocked */ }
    setFilter(page, initialFilter(window.location.hash, sessionRaw, start.vehicle));
    var lastKey = keyOf(start.vehicle);
    function ready() {
      var api = window.FalcxVehicle;
      if (!api) return;
      function sync() {
        var active = api.getActive();
        show(page, active, api.isMine(active));
        /* A new Falcon picked (here or in the header) selects its series in the filter. */
        var k = keyOf(active);
        if (k && k !== lastKey) setFilter(page, active.series, {remember: true});
        if (k) lastKey = k;
      }
      document.addEventListener('falcx:vehicle-change', sync);
      document.addEventListener('falcx:browsing-change', sync);
      /* A choice made here goes into the address too, so the page can be shared or reloaded as it is. */
      page.addEventListener('click', function (e) {
        var pill = e.target && e.target.closest ? e.target.closest('[data-fxft-pick] [data-body]') : null;
        if (pill) setTimeout(function () { write(api.getActive()); }, 0);
      });
      var select = page.querySelector('[data-fxft-pick] select[name="series"]');
      if (select) select.addEventListener('change', function () { setTimeout(function () { write(api.getActive()); }, 0); });
      sync();
      /* r8 sweep: the finder paints its controls again after Horizon's header morph (no event), which put "EA–ED" and a
         pressed "Sedan" back into the empty picker under "Choose your series first". Put the empty state back. */
      var pick = page.querySelector('[data-fxft-pick]');
      if (pick && typeof MutationObserver === 'function') new MutationObserver(function () {
        if (api.getActive() || !pick.classList.contains('is-empty')) return;
        if ((select && select.value) || pick.querySelector('[data-body][aria-pressed="true"], [data-body]:not([disabled])')) show(page, null, false);
      }).observe(pick, {attributes: true, subtree: true, attributeFilter: ['aria-pressed', 'hidden', 'disabled']});
    }
    function write(v) {
      if (!v || !window.history.replaceState) return;
      var next = canonicalSearch(window.location.search, v);
      if (next) window.history.replaceState(null, '', window.location.pathname + next + window.location.hash);
    }
    /* The panels are shown already; the rest waits for the whole page (and falcx-finder.js, which is deferred). */
    function later() {
      setFilter(page, page.getAttribute('data-fxfp'));
      page.addEventListener('click', function (e) {
        var chip = e.target && e.target.closest ? e.target.closest('[data-fxfp-chip]') : null;
        if (chip) setFilter(page, chip.getAttribute('data-fxfp-chip'), {announce: true, remember: true});
      });
      ready();
      hashLinks(page);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
    back(document.querySelector('[data-fx-back]'));
  }

  function show(page, v, mine) {
    var key = keyOf(v);
    shownKey = key;
    var found = false;
    page.querySelectorAll('[data-fxft-result]').forEach(function (panel) {
      var on = panel.getAttribute('data-fxft-result') === key;
      if (on) found = true;
      if (panel.hidden === on) panel.hidden = !on;
      if (on) {
        var k = panel.querySelector('[data-fxft-kicker]');
        if (k && k.textContent !== kicker(mine)) k.textContent = kicker(mine);
      }
    });
    var prompt = page.querySelector('[data-fxft-prompt]');
    if (prompt) prompt.hidden = found;
    page.querySelectorAll('[data-fxft-row]').forEach(function (row) {
      var on = row.getAttribute('data-fxft-row') === key;
      row.classList.toggle('is-on', on);
      if (on) row.setAttribute('aria-current', 'true'); else row.removeAttribute('aria-current');
    });
    /* The picker shows a choice only once there is one (the finder would otherwise show EA–ED Sedan as picked). */
    var pick = page.querySelector('[data-fxft-pick]');
    if (pick) {
      pick.classList.toggle('is-empty', !found);
      var select = pick.querySelector('select[name="series"]');
      if (select) select.value = found ? v.series : '';
      pick.querySelectorAll('[data-body]').forEach(function (b) {
        if (!found) { b.hidden = false; b.disabled = true; b.setAttribute('aria-pressed', 'false'); }
        else {
          var valid = false;
          page.querySelectorAll('[data-fxft-result]').forEach(function (p) { if (p.getAttribute('data-fxft-result') === v.series + '/' + b.getAttribute('data-body')) valid = true; });
          b.hidden = !valid; b.disabled = false; b.setAttribute('aria-pressed', String(b.getAttribute('data-body') === v.body));
        }
      });
      var hint = pick.querySelector('[data-fxft-hint]');
      if (hint) hint.hidden = found;
    }
  }

  /* Horizon scrolls .page-wrapper, not the window, so the browser's own jump to /pages/…#rear on load does not happen
     and smooth in-page jumps can stall: scroll the target into view here (scroll-margin keeps it clear of the header). */
  function jumpTo(id, smooth) {
    var el = id && document.getElementById(id);
    if (!el) return null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({behavior: smooth && !reduce ? 'smooth' : 'instant', block: 'start'});
    return el;
  }
  function jumpOnLoad() {
    var id = decodeURIComponent((window.location.hash || '').slice(1));
    if (!id || !document.getElementById(id)) return;
    var moved = false;
    function stop() { moved = true; }
    ['wheel', 'touchstart', 'keydown'].forEach(function (t) { window.addEventListener(t, stop, {once: true, passive: true}); });
    setTimeout(function () { jumpTo(id, false); }, 0);
    /* Images above the target can still change the layout until the page has loaded. */
    window.addEventListener('load', function () { if (!moved) jumpTo(id, false); });
  }
  function hashLinks(root) {
    jumpOnLoad();
    /* A link from outside the page body (header, another tab's history) to a card the filter hides. */
    window.addEventListener('hashchange', function () {
      var id = decodeURIComponent((window.location.hash || '').slice(1));
      if (!id || !document.getElementById(id)) return;
      reveal(root, id);
      jumpTo(id, true);
    });
    root.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      reveal(root, id);
      var el = jumpTo(id, true);
      if (!el) return;
      e.preventDefault();
      if (window.history.replaceState) window.history.replaceState(null, '', window.location.pathname + window.location.search + '#' + id);
      var head = el.matches('h2, h3') ? el : el.querySelector('h2, h3');
      if (head) { if (!head.hasAttribute('tabindex')) head.setAttribute('tabindex', '-1'); try { head.focus({preventScroll: true}); } catch (err) { /* old browser */ } }
    });
  }

  /* "Back to …" for a visit from a product or collection page on this shop (also when it opened in a new tab). */
  function backTarget(referrer, origin) {
    if (!referrer) return null;
    var u;
    try { u = new URL(referrer); } catch (e) { return null; }
    if (u.origin !== origin) return null;
    if (/^\/products\/[^/]+\/?$/.test(u.pathname)) return {href: u.pathname + u.search, kind: 'product', json: u.pathname.replace(/\/$/, '') + '.js'};
    if (/^\/collections\//.test(u.pathname)) return {href: u.pathname + u.search, kind: 'collection'};
    return null;
  }
  function back(link) {
    if (!link || typeof document === 'undefined') return;
    var t = backTarget(document.referrer, window.location.origin);
    if (!t) return;
    link.href = t.href;
    var label = link.querySelector('[data-fx-back-label]') || link;
    label.textContent = t.kind === 'product' ? 'Back to the product' : 'Back to the shop';
    if (t.kind === 'product' && window.fetch) {
      fetch(t.json, {headers: {Accept: 'application/json'}}).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (p && p.title) label.textContent = 'Back to ' + p.title;
      }).catch(function () {});
    }
  }

  return {normalize: normalize, resolve: resolve, parseSaved: parseSaved, initial: initial, canonicalSearch: canonicalSearch, kicker: kicker, keyOf: keyOf, backTarget: backTarget, hashFilter: hashFilter, initialFilter: initialFilter, filterStatus: filterStatus, boot: boot};
}));